(function () {
    window.addEventListener('DOMContentLoaded', () => {
      const action_info = document.querySelector('.js-info-tooltip');
      const action_info_close = document.querySelector('.js-info-tooltip-modal__close');
      const html = document.querySelector('html');
      const show_tooltip_popup = document.querySelector('.js-show-tooltip-modal');

      let lastScroll = 0;

      // Open modal
      action_info.addEventListener('click', function (e) {
        e.preventDefault();
        show_tooltip_popup.style.display = 'block';
        lastScroll = window.scrollY;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';

        // hack because of added animation
        setTimeout(() => {
          document.body.style.top = '-' + lastScroll + 'px';
        }, 0);
      });

      // Close Modal
      action_info_close.addEventListener('click', function (e) {
        e.preventDefault();

        show_tooltip_popup.style.display = 'none';
        document.body.style.overflow = '';
        document.body.style.position = '';
        window.scrollTo(0, +document.body.style.top.replace('px', '') * -1);
        document.body.style.top = '';
      });
    });
  })();
